<div class="StorymapLayout">

    <portal to="AppHeader">

        <ScrollMenu :containerId="containerId" :key="containerId" class="ToolbarItem" style="width:200px" />
        <h1>{{title}}</h1>
        <div style="flex:1"></div>
        <SmartButton class="ToolbarItem" :key="containerId" @click="onInfoButtonClick">
            Info
        </SmartButton>
        <SmartButton class="ToolbarItem" v-if="portrait" :key="containerId" @click="onToggleButtonClick">
            {{getToggleButtonLabel()}}
        </SmartButton>


    </portal>

    <div :class="getDynamicClass()">
        <!-- TODO: Understand why the resize event stops firing after the root element has been resized to minimal width -->
        <!-- Because of this problem, we must add the v-onresize directive to the right child column instead of to the root element-->

        <div :style="getPanel2Style()" class="StorymapLayout__Panel2" ref="panel2" v-onresize="onResize">
            <slot name="panel2" />
        </div>

        <div :style="getPanel1Style()" class="StorymapLayout__Panel1" ref="panel1" :id="containerId">
            <div data-scroll-sensor-container="true" style="height:100%;overflow:auto;flex:0.4">
                <slot name="panel1" />
            </div>
        </div>
    </div>

    <SidebarPanel :show.sync="showInfoPanel" title="Über diese Storymap">
        <slot name="info">
            
        </slot>
    </SidebarPanel>
</div>